/**
 * Main App class.
 */
export class Menu{
  /**
  * Constructor
  */
  constructor() {
    this.menu = document.querySelector('.menu');
    this.burger = document.querySelector('.burger-button');
    this.closer = document.querySelector('.sub-closer');
    this.withChildren = document.querySelectorAll('.menu-item-has-children');

    this.toggleMenuLevel1 = this.toggleMenuLevel1.bind(this);
    this.toggleMenuLevel2 = this.toggleMenuLevel2.bind(this);
    this.init = this.init.bind(this);
  }

  toggleMenuLevel1() {
    this.burger.addEventListener('click', () => {
        this.menu.classList.toggle('active')
        this.burger.classList.toggle('open');
    });
  }

  toggleMenuLevel2() {
      this.withChildren.forEach(element => {
          element.addEventListener('click', e => {
            element.classList.add('active');
            this.burger.classList.add('hidden');
            this.closer.classList.remove('hidden');
        });
      });

      this.closer.addEventListener('click', () => {
          this.withChildren.forEach(element => {
            element.classList.remove('active');
            this.burger.classList.remove('hidden');
            this.closer.classList.add('hidden');
          });
      })
  }

  init() {
      this.toggleMenuLevel1();
      this.toggleMenuLevel2();
  }
}


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
